import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { HttpService } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorRegistrationWithCodeController extends AbstractStepController {

    onContextChange(contextChange: ContextChange) {
        if (contextChange.key === TerminalContextConstants.registrationCode && contextChange.value != null && contextChange.value.replace(/\s+/g, '').length === 10) {
            this.onOnRegistrationCode();
        }
    }

    onRegisterToDashboardContext() {
    }

    onOnRegistrationCode() {

        const httpService = WizardServiceLocator.injector.get(HttpService);

        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
        return httpService.postWithContext(`${environment.registrationVisitorCodeEndpoint}`, {
            code: this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode)
        }).toPromise().then((response: TerminalVisitorRegistration) => {
            this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
            this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
            if (response.status !== ResponseStatus.FAILED) {

                const registration = new TerminalVisitorRegistration(response);

                this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
                this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
                this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
                this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
                this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
                this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
                this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
                this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
                this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', registration.needsAreaAccess);
                this.dashboardContext.setContextValue('visitorType', registration.visitorType);
                this.dashboardContext.setContextValue('inviteAdditionalVisitorsAllowed', registration.inviteAdditionalVisitorsAllowed);
                this.dashboardContext.setContextValue('instructionsDone', registration.instructionsDone);
                this.dashboardContext.setContextValue('inviterId', registration.inviterId);
                if (registration.inYard) {
                  const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
                  logContainer.addLog('start leave process');
                  this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
                } else {
                  const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
                  logContainer.addLog('register visitor manually started');
                  this.onOnRegistrationCodeValid();
                }
            } else {
              this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
            }
        }, error => {
            // TODO specify what happens for bad codes
        });
    }

    private onOnRegistrationCodeValid() {
      this.wizardComponent.next();
    }


    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('register with code started');

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;

        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();

        let spacer = new StepControl();
        spacer.type = StepControlType.SPACER_GROW;
        controls.push(spacer);

        const cancelControl = new StepControl();
        cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
        cancelControl.type = StepControlType.BUTTON_STROKED;
        cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
        cancelControl.controlAction = this.cancel.bind(this);
        controls.push(cancelControl);


        const showCreateNewRegistrationButton = this.wizardComponent.currentStep.dashboardConfiguration?.showCreateNewRegistrationButton;

        this.dashboardContext.setContextValue('newRegistrationEnabled', showCreateNewRegistrationButton == true);
        this.dashboardContext.setContextValue('qrCodeScanEnabled', this.wizardComponent.currentStep.dashboardConfiguration?.qrCodeScanEnabled == true);


        return controls;
    }
}
